module.exports = __webpack_public_path__ + "static/media/veracity.4517e0be.png";